import React, { useMemo, useRef, useState } from "react";
import { useIsOverflowing } from "../../hooks";
import Button from "../Button/Button";
import styles from "./nLinesShowMore.module.scss";
/**
 * Line-clamp multiple lines of text. For a single line use `OneLineShowMore`.
 * @param id Id for the "show more" button
 * @param value Text to display
 * @param numberOfLines Lines to display before clamping
 */
const NLinesShowMore = ({ id, value, numberOfLines, }) => {
    const [showMore, setShowMore] = useState(false);
    const ref = useRef(null);
    const isOverflowing = useIsOverflowing(ref);
    const style = useMemo(() => ({ WebkitLineClamp: numberOfLines }), [numberOfLines]);
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement(React.Fragment, null,
            React.createElement("div", { ref: ref, className: styles.content, style: !showMore ? style : undefined }, value),
            isOverflowing || showMore ? (React.createElement(Button, { variant: "text", isInline: true, id: id, onClick: () => setShowMore(!showMore), className: styles.button },
                "Show ",
                showMore ? "less" : "more")) : null)));
};
export default NLinesShowMore;
//# sourceMappingURL=NLinesShowMore.js.map